<template>
  <el-row type="flex" class="project-user" v-show="!infoVisible && !statisticsVisible">
    <left-tree v-if="showLeftTree" :id="project.id?project.id:''" class="left-box"  @project-change="projectChange" />
    <div class="right-box">
      <div class="top-tit">
        <div class="form-cen-tit" v-if="currLabel">{{ currLabel }}</div>
      </div>
      <el-row type="flex" justify="space-between" class="pro-user-con">
        <div>
          <div style="display: inline-block;">
            <img :src="qrIcon" alt="" @click="toShowProjectQrCode()" style="cursor:pointer;">
            <!-- <div>邀请人员</div> -->
          </div>
          <el-button type="primary" @click="toExport" v-if="isExportPower" icon="download">导出</el-button>
          <el-button type="primary" v-if="isStatisticsPower" @click="statisticsVisible = true"
            icon="data-analysis">人员统计分析</el-button>
          <el-button type="primary" v-if="isManagerPower" @click="toChange" icon="OfficeBuilding">组织变更</el-button>
        </div>
        <div>
          <el-select v-model="isCurrentLevel" placeholder="人员层级"  style="width: 130px;margin-right:15px;"
            @change="searchData">
            <el-option :value="1" label="直属当前群组">直属当前群组</el-option>
            <el-option :value="0" label="所有当前群组">所有当前群组</el-option>
          </el-select>
          <el-select v-model="params.workerStatus" placeholder="在场状态" clearable style="width: 100px;margin: 0 15px;"
            @change="searchData">
            <el-option value="" label="全部"></el-option>
            <el-option value="在场" label="在场"></el-option>
            <el-option value="离场" label="离场"></el-option>
          </el-select>
          <el-select v-model="params.auditStatus" placeholder="审核状态" clearable style="width: 100px;margin: 0 15px;"
            @change="searchData">
            <el-option :value="0" label="待审核"></el-option>
            <el-option :value="1" label="审核通过"></el-option>
          </el-select>
          <el-input v-model="params.query" style="width: 230px" @change="searchData" clearable
            placeholder="姓名、手机号、身份证号搜索"></el-input>
          <el-button type="primary" @click="searchData" icon="refresh">搜索</el-button>
        </div>
      </el-row>
      <el-row type="flex" justify="center" class="pro-user-con">
        <div style="width: 10%;">
          <span style="color: rgb(58, 142, 230);font-weight: 600;">总人数：</span>
          <span style="color: rgb(102, 177, 255);font-weight: 800;font-size: 18px;display: inline-block;">{{ userTotal }}</span>
        </div>
        <div style="width: 10%;">
          <span style="color: rgb(58, 142, 230);font-weight: 600;">在场人数：</span>
          <span style="color: rgb(102, 177, 255);font-weight: 800;font-size: 18px;display: inline-block;">{{ haveTotal }}</span>
        </div>
        <div style="width: 10%;">
          <span style="color: rgb(58, 142, 230);font-weight: 600;">离场人数：</span>
          <span style="color: rgb(102, 177, 255);font-weight: 800;font-size: 18px;display: inline-block;">{{ leaveTotal }}</span>
        </div>
      </el-row>
      <el-table :data="users" tooltip-effect="dark" border stripe height="calc(100vh - 270px)"
        row-key="id" default-expand-all v-loading="loading" class="pro-user-table" @selection-change="handleSelectionChange">
        <el-table-column v-for="(column, index) in tableColumns" :key="index" :type="column.type" :prop="column.prop"
          :label="column.label" :width="column.width" :min-width="column.minWidth" :formatter="column.formatter"
          :fixed="column.fixed">
        </el-table-column>
        <el-table-column label="二维码" width="100">
          <template #default="{row}">
            <img :src="qrIcon" alt=""  @click="toShowUserQrCode(row)" style="cursor:pointer;">
          </template>
        </el-table-column>
        <el-table-column label="审核状态" width="100">
          <template #default="{row}">
            <el-tag v-if="row.auditStatus === 0">待审核</el-tag>
            <el-tag v-if="row.auditStatus === 1" type="success">审核通过</el-tag>
            <el-tag v-if="row.auditStatus === 2" type="danger">审核驳回</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="管理员" width="100">
          <template #default="{row}">
            <el-switch active-text="是" inactive-text="否" :model-value="row.isAdministration" inline-prompt
              @change="isAdministrationChange(row)" :disabled="!isManagerPower || row.auditStatus != 1"></el-switch>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="150" fixed="right" v-if="isInfoPower || isManagerPower || isDeletePower">
          <template #default="{row}">
            <el-button type="text" v-if="isInfoPower" @click="toInfo(row)">详情</el-button>
            <el-button type="text" v-if="isManagerPower" @click="toWorkersStatusChange(row)">{{row.workersStatus == '在场' ? '离场' : '复工'}}</el-button>
            <el-button type="text" v-if="isDeletePower && isNoShowDelUser(row)" @click="toDelete(row)" style="color: red;">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total"
        :current-page="params.pageNo" :page-size="params.length" @current-change="pageNoChange"
        @size-change="lengthChange">
      </el-pagination>
    </div>
  </el-row>

  <el-dialog v-model="workersStatusChangeVisible" title="提示" width="400px">
    <span>使当前人员{{currUser.workersStatus == '在场' ? '离场' : '复工'}}</span>
    <el-date-picker type="datetime" v-model="workerStatusOpTime" format="YYYY-MM-DD hh:mm:ss"
      value-format="YYYY-MM-DD hh:mm:ss" style="margin-left: 25px;"></el-date-picker>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="workersStatusChangeVisible = false">取消</el-button>
        <el-button type="primary" @click="workersStatusChange">确认</el-button>
      </span>
    </template>
  </el-dialog>

  <el-dialog v-model="showOrgnazitionTree" title="人员组织变更" width="800px">
    <div style="overflow-y: auto;height:600px;">
      <el-tree 
      ref="orgTree" 
      node-key="id" 
      :highlight-current="true" 
      :current-node-key="currData.id" 
      size="large"
      :data="projects" 
      @node-click="nodeClick" 
      class="left-tree"
      :expand-on-click-node="true"
      >
      <template #default="{ data }">
        <span class="custom-tree-node">
          <span v-if="data.type == 'PROJECT'">
            <!-- <el-icon :size="16"><folder-opened /></el-icon> -->
            <!-- {{ data.projectName + ' ( ' + (data.userNum || 0) + ' ) ' }} -->
            <span style="margin-left: 10px;">
              <span style="background: #39a3ff;padding: 2px 5px;font-size: 12px;font-weight: bold;color: white;">项目</span> 
              {{ data.projectName }}
              </span>
          </span>
          <span v-else-if="data.type == 'TEAM'">
            <!-- <el-icon :size="16"><flag /></el-icon> -->
            <!-- {{ data.teamName + ' ( ' + (data.userNum || 0) + ' ) ' }} -->
            <span style="margin-left: 10px;">
              <span style="background: #51D351;padding: 2px 5px;font-size: 12px;font-weight: bold;color: white;">施工队</span> 
              {{ data.teamName }} 
              </span>
          </span>
          <span v-else-if="data.type == 'GROUP'">
            <!-- <el-icon :size="16"><user-filled /></el-icon> -->
            <!-- {{ data.groupName + ' ( ' + (data.userNum || 0) + ' ) ' }} -->
            <span style="margin-left: 10px;">
              <span style="background: #FFA94C;padding: 2px 5px;font-size: 12px;font-weight: bold;color: white;">班组</span>
              {{ data.groupName }}
              </span>
          </span>
        </span>
      </template>
    </el-tree>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="showOrgnazitionTree = false">取消</el-button>
        <el-button type="primary" @click="confirmOrgnazitionChange">确认</el-button>
      </span>
    </template>
  </el-dialog>
  <show-qr-code :params="qrCodeParams" v-model="qrCodeVisible" />
  <pro-user-info :user="currUser" v-if="infoVisible" v-model="infoVisible" />
  <user-statistics :project="project" :queryParams="queryParams" v-if="statisticsVisible" v-model="statisticsVisible" />
</template>

<script>
import { defineComponent } from 'vue';
import { getProjectOrgLabel } from '@/api/index';
import LeftTree from './LeftTree.vue'
import qrIcon from '@/assets/icon/qrCode.png';
import ShowQrCode from '@/components/ShowQrCode.vue';
import ProUserInfo from './info/Index.vue';
import UserStatistics from './statistics/Index.vue';
import { changeIsAdministration, changeWorkersStatus, deleteProUserById, exportProUserByQuery, getProUserByQuery,getProjectTreeList,orgnazitionChange} from '@/api/proman/prouser';
import { exportFile } from '@/utils/fileUtil';
import { deepClone, isHaveOrgPower } from '@/utils/common';
import { mapGetters } from 'vuex';

export default defineComponent({
  components: { LeftTree, ShowQrCode, ProUserInfo, UserStatistics },
  data() {
    return {
      loading: false,
      qrIcon,
      qrCodeParams: {}, // 二维码显示参数
      qrCodeVisible: false, // 二维码显示与否
      project: {},
      users: [],
      infoVisible: false, // 是否显示详情
      currUser: {}, // 当前人员
      statisticsVisible: false, // 是否显示人员统计分析
      total: 0,
      tableColumns: [
        { type: 'selection' },
        { type: 'index', width: 55, label: '序号' },
        { prop: 'name', label: '姓名', minWidth: 120 },
        { prop: 'isProject', label: '所在项目层级', minWidth: 120, formatter: row => {
          if (row.isProject === 1) return row.projectName;
          if (row.isTeam === 1) return row.teamName;
          if (row.isGroup === 1) return row.groupName;
          return '';
        } },
        { prop: 'phone', label: '手机号', width: 120},
        { prop: 'workersStatus', label: '人员状态', width: 90}
      ],
      params: {
        pageNo: 1,
        length: 20,
        query: '',

       auditStatus: 1, // 审核状态
       workerStatus:'',
      },
      selection: [],
      workersStatusChangeVisible: false, // 工作状态改变显示
      workerStatusOpTime: null, // 操作时间

       //显示直属当前群组层级的人员
       isCurrentLevel:1,
       showOrgnazitionTree:false,
       projects: [],
       currData: {},
       userTotal:'',
       haveTotal:'',
       leaveTotal:'',
       showLeftTree:true,
    }
  },
  mounted() {
    this.getOrgnazitionTreeData();
  },
  computed: {
    ...mapGetters(['orgId']),
    currLabel() {
      let project = this.project;
      if(!project){
        return "";
      }
      let label = project.projectShortName || project.projectName;
      if (project.teamName) {
        label += ' > ' + project.teamName;
      }
      if (project.groupName) {
        label += ' > ' + project.groupName;
      }
      return label
    },
    queryParams() {
      let ret = { ...this.params };
      let project = this.project;
      if (project.type === 'PROJECT') {
        ret.projectId = project.id;
        ret.isProject=this.isCurrentLevel
      } else if (project.type === 'TEAM') {
        ret.teamId = project.id;
        ret.isTeam=this.isCurrentLevel
      } else if (project.type === 'GROUP') {
        ret.groupId = project.id;
        ret.isGroup=this.isCurrentLevel
      }
      return ret;
    },
    isDeletePower() { // 删除权限
      return this.isProAdmin('99642756791534519');
    },
    isInfoPower() { // 人员详情权限
      return this.isProAdmin('99642756791534520');
    },
    isStatisticsPower() { // 人员统计权限
      return this.isProAdmin('99642756791534521');
    },
    isManagerPower() { // 管理员设置权限（）
      return this.isProAdmin('99642756791534522');
    },
    isExportPower() { // 人员导出权限
      return this.isProAdmin('99642756791534523');
    }
  },
  methods: {
    isProAdmin(powerId) {
      if(isHaveOrgPower(powerId)){
          return true;
      }
      let project = this.project;
      return project.isProjectAdministration === 1 || project.isTeamAdministration === 1 || project.isGroupAdministration === 1;
    },
    searchData() {
      this.params.pageNo = 1;
      this.getData();
    },
    pageNoChange(pageNo) {
      this.params.pageNo = pageNo;
      this.getData();
    },
    lengthChange(length) {
      this.params.length = length;
      this.searchData();
    },
    getData() { // 获取人员列表
      // this.loading = true;
      getProUserByQuery(this.queryParams).then(({data}) => {
        data.data.data.forEach(proUser => proUser.isAdministration = proUser.isProjectAdministration === 1
          || proUser.isTeamAdministration === 1 || proUser.isGroupAdministration === 1);
        this.users = data.data.data;
        this.userTotal = data.data.total;
        this.haveTotal = data.data.have;
        this.leaveTotal = data.data.leave;
        this.total = data.page.totalRecords;
      })
    },
    projectChange(project) { // 项目层级改变事件
      this.project = project;
      this.searchData();
    },
    toShowProjectQrCode() { // 展示项目二维码
      let project = this.project;
      let type = 1;
      let params = { projectId: project.id }
      if (project.teamName) {
        type = 3;
        params = { teamId: project.id }
      }
      if (project.groupName) {
        type = 2;
        params = { groupId: project.id }
      }
      params.isLogo = true;
      getProjectOrgLabel(params).then(({data}) => {
        let labelArr = data.data.split("---logo:");
        this.qrCodeParams = {
          id: project.id,
          type,
          label: labelArr[0],
            subLabel: '快使用微信扫一扫,，加入项目组吧',
          logo: labelArr[1]
        }
        
        this.qrCodeVisible = true;
      })
    },
    toShowUserQrCode(user) { // 显示人员二维码
      let params = {
        id: user.id,
        type: 4,
        title: '项目人员二维码'
      }
      this.qrCodeParams = params;
      this.qrCodeVisible = true;
    },
    toInfo(user) { // 查看人员详情
      this.currUser = user;
      this.infoVisible = true;
    },
    isAdministrationChange(proUser) {
      this.$confirm('改变当前人员管理员状态？', '提示').then(_ => {
        changeIsAdministration(proUser.id).then(({data}) => {
          if (data.status) {
            this.$message.success(data.msg);
            this.getData();
          } else {
            this.$message.warning(data.msg);
          }
        })
      }).catch(_ => {})
    },
    toWorkersStatusChange(proUser) {
      this.currUser = proUser;
      this.workerStatusOpTime = null;
      this.workersStatusChangeVisible = true;
    },
    workersStatusChange() { // 改变人员在所/离场状态
      changeWorkersStatus(this.currUser.id, this.workerStatusOpTime).then(({data}) => {
        if (data.status) {
          this.$message.success(data.msg);
          this.workersStatusChangeVisible = false;
          this.getData();
        } else {
          this.$message.warning(data.msg);
        }
      }).catch(_ => {})
    },
    toDelete(row) {
      let that =this;
      this.$confirm('确定删除此人员？', '提示').then(_ => {
        deleteProUserById(row.id, row.projectId, that.project.type).then(({data}) => {
          if (data.status) {
            this.$message.success(data.msg);
            this.getData();
          } else {
            this.$message.warning(data.msg);
          }
        })
      }).catch(_ => {});
    },
    toExport() {
      let queryParams = this.queryParams;
      if (this.selection && this.selection.length) {
        queryParams = deepClone(this.queryParams);
        let ids = [];
        this.selection.forEach(sel => ids.push(sel.id));
        queryParams.ids = ids;
      }
      exportProUserByQuery(queryParams).then(res => exportFile(res))
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    //判断是否可以删除
     isNoShowDelUser(row) { 
      let project = this.project;
      if(project.type=="PROJECT"){
          return row.isProject === 1;
      }else if(project.type=="TEAM"){
          return row.isTeam === 1;
      }else if(project.type=="GROUP"){
          return row.isGroup === 1;
      }
      return false;
     },
     getOrgnazitionTreeData() {
      getProjectTreeList({currentPage: 1, pageSize: 100000,questType:"USERTREE"}).then(({data}) => {
        this.projects = data.data;
      //  if (this.projects.length) {
      //     this.currData=this.projects[0]
      //     if(this.id){
      //         this.projects.forEach(pro => {
      //           if(pro.id===this.id){
      //             this.currData=pro;
      //           }
      //         });
      //     }
      //     this.$nextTick(function () {
      //         this.$refs['orgTree'].setCurrentKey(this.currData.id)
      //     })
      //     //this.$emit('project-change', this.currData);
      //   }
        
      });
    },
    nodeClick(data) {//console.log(data);
      this.currData = data;
      // this.$emit('project-change', data);
      this.$nextTick(function () {
          this.$refs['orgTree'].setCurrentKey(this.currData.id)
      })
    },
    toChange(){//console.log(this.selection);
      if(!this.selection||this.selection.length<=0){
        this.$message.warning("请选择需要变更的人员！");
        return;
      }
      this.showOrgnazitionTree=true;
    },
    confirmOrgnazitionChange(){console.log('adsfasdf');
      if(!this.currData){
        this.$message.warning("请选择需要加入的组织！");
        return;
      }
      let userIds=[];
      this.selection.map((v,i)=>{
        userIds.push(v.id);
      });
      orgnazitionChange({userIds:userIds.join(','),type:this.currData.type,orgnId:this.currData.id}).then((data)=>{console.log('this.project',this.project)
        if(data.data&&true==data.data.status){
          this.showLeftTree=false;
          this.$message.success(data.data.msg);
          this.showOrgnazitionTree=false;
          this.$nextTick(()=>{
            this.showLeftTree=true;
          });
          this.getData();
        }else{
          this.$message.error(data.data.msg);
        }
      });
    }
  }
})
</script>

<style lang="scss" scoped>
.project-user {
  height: 100%;
  .left-box {
    width: 20%;
    height: calc(100% - 40px);
    border-right: 1px solid #ccc;
    padding: 20px 10px;
  }
  .right-box {
    .top-tit{
      display: flex;
      .form-cen-tit{
        padding: 5px 25px 5px 5px;
        background: linear-gradient(-45deg,transparent 20px, #0099ff 0) bottom right,
                    linear-gradient(-135deg,transparent 20px,#00548c 0) top right;
        color: white;
        font-size: 14px;
        font-weight: bold;
        min-width: 200px;
      }
    }
    width: calc(80% - 61px);
    padding: 20px;
    .pro-user-con {
      align-items: center;
      margin-top: 15px;
      >div:first-child {
        display: flex;
        align-items: center;
        >div:first-child {
          text-align: center;
          margin-right: 15px;
        }
        &+div {
          .el-button {
            margin-left: 15px;
          }
        }
      }
    }
    .pro-user-table {
      margin-top: 15px;
      margin-bottom: 15px;
    }
  }
}
</style>